import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";
import { StorageZap } from "./useQueryStorageZaps";
interface Input {
  onSuccess: (data: Partial<StorageZap>) => void;
  onError: (errorMessage: string) => void;
  folderId?: string; // used for cache invalidation
}

export function useDuplicateZap({ onSuccess, onError, folderId }: Input) {
  const utils = trpc.useUtils();
  const queryClient = useQueryClient();

  const mutation = trpc.zap.duplicate.useMutation({
    onSuccess: (data) => {
      // Refetch instead of manually updating cache to get new owner info, timestamps, and draft versions
      onSuccess(data.zdl);
      const storageKey = getQueryKey(trpc.zap.storageZaps, undefined, "any");
      queryClient.refetchQueries({ queryKey: storageKey });
      const orgKey = getQueryKey(trpc.zap.organizationZaps, undefined, "any");
      queryClient.refetchQueries({ queryKey: orgKey });
      const searchKey = getQueryKey(trpc.zap.searchZaps, undefined, "any");
      queryClient.refetchQueries({ queryKey: searchKey });

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }
    },
    onError: (error) => {
      onError(error.message);
    },
  });

  return {
    duplicateZap: mutation.mutate,
    isDuplicating: mutation.isPending,
  };
}
